import React, { useState } from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";
import InputField from "components/Input";
import Loading from "components/Loading";
import RadioButton from "../RadioButton";

const SelectFarmModal = ({
  farms,
  isOpen,
  onClose,
  handleSearch,
  handleSelectNewFarm,
  searchFarmName,
  isLoading,
}) => {
  const [selectedFarm, setSelectedFarm] = useState(null);
  const [selectedNewFarm, setSelectedNewFarm] = useState(null);

  const handleOnClose = () => {
    onClose();
  };

  const handleSelectFarm = (farm) => {
    let newSelectedFarm;
    if (selectedFarm?.length > 0) {
      newSelectedFarm = farm;
    } else {
      newSelectedFarm = farm;
    }
    setSelectedFarm(newSelectedFarm);
    setSelectedNewFarm(newSelectedFarm);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="select-farm" data-testid="select-modal-content">
        <h3 className="title">Select Farm</h3>
        <div className="search-farm">
          <InputField
            placeholder="Search for farm name"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchFarmName}
          />
        </div>
        {isLoading ? (
          <div className="loading-wrapper">
            <Loading />
          </div>
        ) : (
          <div className="farm-list">
            {farms
              ? farms.map((farm) => (
                  <div
                    className="farm-item"
                    onClick={() => setSelectedFarm(farm.id)}
                    aria-hidden
                  >
                    <RadioButton
                      checked={selectedFarm?.id === farm.id}
                      onChange={() => handleSelectFarm(farm)}
                      label={farm.properties.farm_name}
                    />
                  </div>
                ))
              : null}
          </div>
        )}
        <div className="action-buttons">
          <Button
            id="select-farm-button"
            type="solid"
            color="green"
            label="Select Farm"
            rounded
            block
            onClick={() => handleSelectNewFarm(selectedNewFarm)}
          />
        </div>
      </div>
    </CustomModal>
  );
};

SelectFarmModal.propTypes = {
  farms: PropTypes.shape({
    features: PropTypes.string.isRequired,
    map: PropTypes.func.isRequired,
    filter: PropTypes.func.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleSelectNewFarm: PropTypes.func.isRequired,
  searchFarmName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default SelectFarmModal;
